module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-manifest@5.16.0_gatsby@5.16.1_graphql@16.13.2/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"シードシステム株式会社","short_name":"Seed System","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"bb35820f1f158d1c933ff74bd9ba1428"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.16.1_babel-eslint@10.1.0_react-dom@18.3.1_react@18.3.1_typescript@6.0.2/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
